import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import AutoInput from "../containers/AutoInput";
import { getValue } from "../utils/models";

class DispatchCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: null,
      customerQuery: "",
      user: this.props.user.id,
      userQuery: "",
      vehicle: null,
      vehicleQuery: "",
      vehicleType: null,
      vehicleTypeQuery: "",
      type: null,
      plateUsa: null,
      plateMx: null,
      isForwarder: false,
      isLeasing: false,
      isCollection: false,
      collectionTransitQuery: "",
      collectionTransit: getValue(this.props.values, "collectionTransit")
    };
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        },
        {
          active: true,
          sapId: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return customerFilter;
  }

  getUserFilter() {
    let userFilter = {
      or: [
        {
          active: true,
          id: this.state.user
        }
      ]
    };

    if (this.state.userQuery) {
      userFilter.or = [
        ...userFilter.or,
        {
          active: true,
          name: {
            contains: this.state.userQuery
          }
        },
        {
          active: true,
          lastName: {
            contains: this.state.userQuery
          }
        }
      ];
    }

    return userFilter;
  }

  getVehicleFilter() {
    let vehicleFilter = {
      or: [
        {
          active: true,
          id: this.state.vehicle
        }
      ]
    };

    if (this.state.vehicleQuery) {
      vehicleFilter.or = [
        ...vehicleFilter.or,
        {
          active: true,
          make: {
            contains: this.state.vehicleQuery
          }
        },
        {
          active: true,
          plateUsa: {
            contains: this.state.vehicleQuery
          }
        },
        {
          active: true,
          plateMx: {
            contains: this.state.vehicleQuery
          }
        }
      ];
    }

    return vehicleFilter;
  }

  getVehicleTypeFilter() {
    let vehicleTypeFilter = {
      or: [
        {
          active: true,
          id: this.state.vehicleType
        }
      ]
    };

    if (this.state.vehicleQuery) {
      vehicleTypeFilter.or = [
        ...vehicleTypeFilter.or,
        {
          active: true,
          name: {
            contains: this.state.vehicleTypeQuery
          }
        }
      ];
    }

    return vehicleTypeFilter;
  }

  getDispatchTypeFilter() {
    let supplier_id = null;

    if (this.state.supplier)
      supplier_id = this.state.supplier === 14 ? "FP" : "FS";

    let dispatchTypeFilter = {
      or: [
        {
          indicator: supplier_id
        }
      ]
    };

    return dispatchTypeFilter;
  }

  getTypeFilter() {
    let ids = [];

    switch (this.state.type) {
      case 4:
        ids = [1, 2];
        break;

      case 3:
        ids = [4];
        break;

      case 2:
        ids = [3, 5];
        break;

      default:
        break;
    }

    if (ids.length) {
      return {
        or: ids.map(id => ({ id }))
      };
    }

    return undefined;
  }

  getLeasingTransits() {
    return {
      isLeasing: true,
      collectionTransit: null
    };
  }

  render() {
    // const userFilter = this.getUserFilter()
    const customerFilter = this.getCustomerFilter();
    const vehicleFilter = this.getVehicleFilter();
    const vehicleTypeFilter = this.getVehicleTypeFilter();
    const dispatchTypeFilter = this.getDispatchTypeFilter();

    // if (this.state.isLeasing) this.setState({ isCollection: false });
    // if (this.state.isCollection) this.setState({ isLeasing: false });

    return (
      <Fragment>
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"createdBy"}
          type={"number"}
          hidden
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"office"}
          filter={{ active: true }}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"billType"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"supplier"}
          onChange={value => {
            this.setState({ supplier: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"type"}
          onChange={value => {
            this.setState({ type: value }, () => {
              this.props.form.setFieldsValue({
                serviceType: value === 3 ? 4 : undefined
              });
            });
          }}
          filter={dispatchTypeFilter}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"serviceType"}
          filter={this.getTypeFilter()}
          required={[2, 3, 4].includes(this.state.type)}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"customer"}
          onSearch={value => {
            this.setState({ customerQuery: value, active: true });
          }}
          needFullValue
          onChange={values => {
            const { id } = JSON.parse(values);

            this.setState({ customer: id });
          }}
          placeholder={"Busca un cliente"}
          filter={customerFilter}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"origin"}
          filter={{ customer: this.state.customer }}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"destination"}
          filter={{ customer: this.state.customer }}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"isLeasing"}
          onChange={checked => this.setState({ isLeasing: checked })}
          value={this.state.isLeasing}
          disabled={this.state.isCollection}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"isCollection"}
          onChange={checked => this.setState({ isCollection: checked })}
          value={this.state.isCollection}
          disabled={this.state.isLeasing}
        />
        {(this.state.isCollection && (
          <AutoInput
            form={this.props.form}
            disabled={this.props.disabled}
            model={"dispatch"}
            id={this.props.id}
            autoSave
            ajax
            attribute={"collectionTransit"}
            value={getValue(this.props.values, "collectionTransit")}
            placeholder={"Ingrese el tránsito"}
            onSearch={value => {
              this.setState({ collectionTransitQuery: value });
            }}
            onChange={value => {
              this.setState({ collectionTransit: value });
            }}
            filter={this.getLeasingTransits()}
          />
        )) ||
          null}
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"pickupCommitmentTime"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"deliveryCommitmentTime"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"vehicle"}
          placeholder={"Ingrese el vehiculo"}
          ajax
          onSearch={value => {
            this.setState({ vehicleQuery: value });
          }}
          onChange={value => {
            const { id, plateUsa, plateMx } = JSON.parse(value);

            this.setState({ vehicle: id, plateUsa, plateMx });
          }}
          filter={vehicleFilter}
          needFullValue={true}
        />
        <AutoInput
          form={this.props.form}
          attribute={"Placas USA"}
          value={this.state.plateUsa}
          disabled
        />
        <AutoInput
          form={this.props.form}
          attribute={"Placas MEX"}
          value={this.state.plateMx}
          disabled
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"vehicletype"}
          placeholder={"Ingrese el tipo de vehiculo"}
          ajax
          onSearch={value => {
            this.setState({ vehicleTypeQuery: value });
          }}
          onChange={value => {
            this.setState({ vehicleType: value });
          }}
          filter={vehicleTypeFilter}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"economicNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"trailerPlates"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"driver"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"comments"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"customsRegime"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"supplierNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"operativeReferenceNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"containerNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"boxNumber"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"uuidReference"}
        />
        <AutoInput
          form={this.props.form}
          model={"dispatch"}
          attribute={"isForwarder"}
          onChange={checked => this.setState({ isForwarder: checked })}
          value={this.state.isForwarder}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(DispatchCreate);



// WEBPACK FOOTER //
// ./src/forms/DispatchCreate.js